// FormattingMixin.js
// Shared formatting utilities for components

export const FormattingMixin = {
    methods: {
        /**
         * Checks if a value is valid JSON
         * @param {*} value - Value to check
         * @returns {boolean} - True if value is valid JSON string
         */
        $_isJson(value) {
            if (typeof value !== 'string') 
                return false;
            const trimmed = value.trim();
            return (
                (trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))
            );
        },

        /**
         * Converts a string to Title Case
         * Handles camelCase conversion: "itemChecklist" -> "Item Checklist"
         * @param {string} str - String to convert
         * @returns {string} - Title cased string
         */
        $_toTitleCase(str) {
            if (!str) 
                return str;

            // Convert camelCase to Title Case
            // e.g., "itemChecklist" -> "Item Checklist"
            const withSpaces = str.replace(/([a-z])([A-Z])/g, '$1 $2');

            // Capitalize first letter of each word
            return withSpaces
                .split(' ')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        }
    }
};
